// extracted by mini-css-extract-plugin
module.exports = {"ColumnWithPane":"NewRiskAssessment_ColumnWithPane__3I90d","infoLink":"NewRiskAssessment_infoLink__2mf2s"};